import { FORMLY_CONFIG, provideFormlyCore } from '@ngx-formly/core';
import { withFormlyPrimeNG } from '@ngx-formly/primeng';
import { TypeDatepicker } from './types/datepicker';
import { TypeMultiSelect } from './types/multiselect';
import { TypeCalendar } from './types/calendar';
import { TypeSelect } from './types/select';
import { TypeSelectLazy } from './types/select-lazy';
import { TranslocoFormFieldWrapper } from './wrappers/transloco.wrapper';
import { TranslocoService } from '@jsverse/transloco';
import { registerTranslateExtension } from './types/translate.extension';

export type {
  FormlySelectLazyFieldConfig,
  SelectLazyProps,
} from './types/select-lazy';

export const formlyCore = [
  provideFormlyCore([
    ...withFormlyPrimeNG(),
    {
      wrappers: [
        { name: 'transloco-form-field', component: TranslocoFormFieldWrapper },
      ],
      types: [
        {
          name: 'calendar',
          component: TypeCalendar,
          wrappers: ['transloco-form-field'],
        },
        {
          name: 'datepicker',
          component: TypeDatepicker,
          wrappers: ['transloco-form-field'],
        },
        {
          name: 'select',
          component: TypeSelect,
          wrappers: ['transloco-form-field'],
        },
        {
          name: 'select-lazy',
          component: TypeSelectLazy,
          wrappers: ['transloco-form-field'],
        },
        {
          name: 'multiselect',
          component: TypeMultiSelect,
          wrappers: ['transloco-form-field'],
        },
        {
          name: 'input',
          wrappers: ['transloco-form-field'],
        },
        {
          name: 'textarea',
          wrappers: ['transloco-form-field'],
        },
      ],
    },
  ]),
  {
    provide: FORMLY_CONFIG,
    multi: true,
    useFactory: registerTranslateExtension,
    deps: [TranslocoService],
  },
];
